import { useQuery } from '@apollo/client'

import { extractByTypename, isEmptyArray, isNotEmptyArray } from '@local/utils'

import { useErrorToast } from '@web/hooks/useErrorToast'
import useMe from '@web/hooks/useMe'
import { convertPlaceRecommend } from '@web/pages/v5/home/DdayRecommendPlacesSection/helper'
import { Nullish } from '@web/types'
import UIRecommandPlacesSection from '@web/ui/pages/home/components/Sections/UIRecommandPlacesSection'

import { DdayRecommendPlacesSectionQuery } from './query'

export interface ConvertedPlaceRecommend {
  id: string
  categoryName: string
  distanceText: Nullish<string>
  images: string[]
  placeName: string
  reviewCountText: string
}

export const DdayRecommendPlacesSection = () => {
  const { login } = useMe()
  const { data, error } = useQuery(DdayRecommendPlacesSectionQuery, { skip: !login })
  useErrorToast(error)
  const { MeSucceed } = extractByTypename(data?.me)
  const bookingsInNDays = MeSucceed?.bookingsInNDays

  const exposedBooking = bookingsInNDays?.bookings?.find(({ placeSummary }) =>
    isNotEmptyArray(placeSummary?.recommendPlaces),
  )

  const { name, recommendPlaces } = exposedBooking?.placeSummary || {}
  if (!name || !recommendPlaces || isEmptyArray(recommendPlaces)) {
    return null
  }

  const convertedPlaces = recommendPlaces.map(place => convertPlaceRecommend(place))

  return (
    <UIRecommandPlacesSection
      remainBookingDays={exposedBooking?.remainDays}
      name={name}
      recommendPlaces={convertedPlaces}
    />
  )
}
